// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Symbol_shadow__3kLEd","svg":"Symbol_svg__KrAC2"};